/* ========== initial state ========== */
const state = () => ({
  AdmissionYear: "",
  tes_id: "",
  StepIndex: 1,
  loading: {
    status: true,
  },
  Onload: true,
  DataStep: null,
  DataStep2: null,
  DataStep3: null,
  DataStep4: null,
  DataStep5: null,

  NavBarActive: {
    ActiveStep1: "active",
    ActiveStep2: "disabled",
    ActiveStep3: "disabled",
    ActiveStep4: "disabled",
    ActiveStep5: "disabled",
    ActiveStep6: "disabled",
  },
});
/* ========== getters ========== */
const getters = {
  _LoadingSTATUS: (state) => {
    return state.loading.status;
  },
  _getAdmissionYear: (state) => {
    return state.AdmissionYear;
  },
  _getTesID: (state) => {
    return state.tes_id;
  },
  _getDateStep: (state) => {
    return state.DataStep;
  },
  _getDateStep2: (state) => {
    return state.DataStep2;
  },
  _getDateStep3: (state) => {
    return state.DataStep3;
  },
  _getDateStep4: (state) => {
    return state.DataStep4;
  },
  _getDateStep5: (state) => {
    return state.DataStep5;
  },
  _getDateStep6: (state) => {
    return state.DataStep6;
  },
  _getStepIndex: (state) => {
    return state.StepIndex;
  },
  _getNavBarActive: (state) => {
    return state.NavBarActive;
  },
  _getOnload: (state) => {
    return state.Onload;
  },
};

/* ========== actions ========== */
const actions = {
  SET_LOADING: async ({ commit }, payload) => {
    await commit("SET_LOADING", payload);
  },
  SetAdmissionYear: async ({ commit }, payload) => {
    try {
      const response = await window.Axios.get(
        `${window.api}get/GetAdmissionYear/`,
        payload
      );
      await commit("SetAdmissionYear", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  SET_Onload: async ({ state }, value) => {
    state.Onload = value;
  },
  SetStepStatus({ state, rootState }, payload) {
    rootState.Main.StepIndex = payload;
    if (payload == 1) {
      state.NavBarActive.ActiveStep1 = "active";
      state.NavBarActive.ActiveStep2 = "disabled";
      state.NavBarActive.ActiveStep3 = "disabled";
      state.NavBarActive.ActiveStep4 = "disabled";
      state.NavBarActive.ActiveStep5 = "disabled";
      state.NavBarActive.ActiveStep6 = "disabled";
    } else if (payload == 2) {
      state.NavBarActive.ActiveStep1 = "disabled";
      state.NavBarActive.ActiveStep2 = "active";
      state.NavBarActive.ActiveStep3 = "disabled";
      state.NavBarActive.ActiveStep4 = "disabled";
      state.NavBarActive.ActiveStep5 = "disabled";
      state.NavBarActive.ActiveStep6 = "disabled";
    } else if (payload == 3) {
      state.NavBarActive.ActiveStep1 = "disabled";
      state.NavBarActive.ActiveStep2 = "disabled";
      state.NavBarActive.ActiveStep3 = "active";
      state.NavBarActive.ActiveStep4 = "disabled";
      state.NavBarActive.ActiveStep5 = "disabled";
      state.NavBarActive.ActiveStep6 = "disabled";
    } else if (payload == 4) {
      state.NavBarActive.ActiveStep1 = "disabled";
      state.NavBarActive.ActiveStep2 = "disabled";
      state.NavBarActive.ActiveStep3 = "disabled";
      state.NavBarActive.ActiveStep4 = "active";
      state.NavBarActive.ActiveStep5 = "disabled";
      state.NavBarActive.ActiveStep6 = "disabled";
    } else if (payload == 5) {
      state.NavBarActive.ActiveStep1 = "disabled";
      state.NavBarActive.ActiveStep2 = "disabled";
      state.NavBarActive.ActiveStep3 = "disabled";
      state.NavBarActive.ActiveStep4 = "disabled";
      state.NavBarActive.ActiveStep5 = "active";
      state.NavBarActive.ActiveStep6 = "disabled";
    } else if (payload == 6) {
      state.NavBarActive.ActiveStep1 = "disabled";
      state.NavBarActive.ActiveStep2 = "disabled";
      state.NavBarActive.ActiveStep3 = "disabled";
      state.NavBarActive.ActiveStep4 = "disabled";
      state.NavBarActive.ActiveStep5 = "disabled";
      state.NavBarActive.ActiveStep6 = "active";
      state.NavBarActive.ActiveStep7 = "disabled";
    }
  },
};

/* ========== mutations ========== */
const mutations = {
  SET_LOADING: (state, data) => {
    state.loading.status = data;
  },
  SetAdmissionYear: (state, data) => {
    state.AdmissionYear = data;
  },
};
/* ========== Export ========== */
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
